import Skeleton from '../skeleton/Skeleton';
import { StyledOfferCard, StyledOffers } from './Offers.styles';

/** The whole page's shape, shown until the first page of offers has arrived. */
const OffersSkeleton = () => (
  <StyledOffers aria-busy="true">
    <main className="offers-main">
      <div className="offers-head">
        <div>
          <Skeleton width={110} height={28} radius="8px" resp />
          <Skeleton width={440} height={14} radius="6px" margin="10px 0 0" resp />
        </div>
        <Skeleton width={124} height={40} radius="18px" resp />
      </div>

      <div className="offers-search">
        <Skeleton width="100%" height={40} radius="14px" />
      </div>

      <div className="offers-grid">
        {Array.from({ length: 4 }).map((_, i) => (
          <StyledOfferCard key={`offer-skeleton-${i}`} style={{ cursor: 'default' }}>
            <div className="card-head">
              <Skeleton width="40px" height="40px" radius="18px" />
              <Skeleton width="16px" height="16px" radius="4px" />
            </div>
            <div className="card-name">
              <Skeleton width="60%" height="18px" radius="6px" />
            </div>
            <div className="card-lead">
              <Skeleton width="80%" height="14px" radius="6px" />
            </div>
            <div className="card-foot">
              <Skeleton width="120px" height="12px" radius="6px" />
            </div>
          </StyledOfferCard>
        ))}
      </div>
    </main>
  </StyledOffers>
);

export default OffersSkeleton;
